import React, { useState } from "react";
import "./Contact.css";

const Contact = ({
    tag = "CONTACT US",
    title = "Let's Build Something Amazing Together",
    description = "Feel free to reach out to us. Whether you're a student, startup, or business, we're ready to help bring your ideas to life.",
    showMap = true,
    background = "black"
}) => {

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {

        e.preventDefault();

        setLoading(true);

        const formData = new FormData(e.target);

        formData.append(
            "access_key",
            process.env.REACT_APP_WEB3FORMS_KEY
        );

        const object = Object.fromEntries(formData.entries());

        const json = JSON.stringify(object);

        try {

            const response = await fetch(
                "https://api.web3forms.com/submit",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    },
                    body: json
                }
            );

            const result = await response.json();

            if (result.success) {

                setSuccess(true);

                e.target.reset();

                setTimeout(() => {
                    setSuccess(false);
                }, 4000);

            }

        } catch (error) {

            console.log(error);

        } finally {

            setLoading(false);

        }

    };

    return (

        <section
            className="contact-section"
            id="contact"
            style={{ background }}
        >

            {success && (

                <div className="success-alert">

                    ✓ Message Sent Successfully

                </div>

            )}

            <div className="contact-container">

                {/* LEFT */}

                <div className="contact-left">

                    <span className="section-tag">

                        {tag}

                    </span>

                    <h2>

                        {title}

                    </h2>

                    <p>

                        {description}

                    </p>

                    {showMap && (

                        <div className="map-card">

                            <iframe
                                title="location"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.372893987892!2d73.860261!3d18.466760999999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x41d2875767b9865f%3A0x5e5ead960872fa23!2sHoryzen%20Technologies!5e0!3m2!1sen!2sin!4v1783960116527!5m2!1sen!2sin"
                                loading="lazy"
                                allowFullScreen
                                referrerPolicy="strict-origin-when-cross-origin"
                            />

                        </div>

                    )}

                </div>

                {/* RIGHT */}

                <div className="contact-right">

                    <form onSubmit={handleSubmit}>

                        <div className="form-group">

                            <input
                                type="text"
                                name="name"
                                required
                                placeholder="Full Name"
                            />

                        </div>

                        <div className="form-group">

                            <input
                                type="tel"
                                name="phone"
                                required
                                placeholder="Phone Number"
                            />

                        </div>

                        <div className="form-group">

                            <input
                                type="email"
                                name="email"
                                placeholder="Email (Optional)"
                            />

                        </div>

                        <div className="form-group">

                            <textarea
                                rows="6"
                                name="message"
                                required
                                placeholder="Tell us about your project..."
                            />

                        </div>

                        <button
                            type="submit"
                            className="submit-btn-contact"
                            disabled={loading}
                        >

                            {loading ? (

                                <>

                                    <div className="spinner"></div>

                                    Sending...

                                </>

                            ) : (

                                "Send Enquiry"

                            )}

                        </button>

                    </form>

                </div>

            </div>

        </section>

    );

};

export default Contact;